import React from 'react';
import BookmarkTitleItemComponent from "../BookmarkTitleItemComponent";

interface Props {
    deleteBkm: (ids: Array<number | string>) => void
}

const BookmarkTitleComponent: React.FC<Props> = ({deleteBkm}) => {
    const titles = ['reload', 'created', 'classification', 'case', 'time', 'duration', 'label', 'status', 'thumbnail', 'delete'];

    const el = document.getElementById('bkm-content');
    let w = 0;
    if (el) {
        w = el.offsetWidth - el.scrollWidth;
    }

    const style = {width: `calc(100% - ${w}px)`};

    return (
        <div style={{width: '100%', height: '40px', background: "#283848"}} >
            <div className='bookmarks__title'
                style={style}
            >
                {
                    titles.map((title, i) =>
                        <BookmarkTitleItemComponent key={title}
                                                    title={title}
                                                    even={i % 2}
                                                    deleteBkm={deleteBkm}
                        /> )
                }
            </div>
        </div>
    );
};

export default BookmarkTitleComponent;